<template>
  <v-sheet class="pa-1 my-4 mx-auto" rounded color="monochrome-05" align="center" link nuxt>
    <div class="ma-4 d-flex">
      <div align="center">
        <AtomsLoadingSkeleton class="rounded-circle" :width="30" :height="30" />
      </div>
      <div class="pa-0 flex-grow-1" align="left">
        <AtomsLoadingSkeleton class="rounded mx-2" :height="60" />
      </div>
    </div>
  </v-sheet>
</template>
